module.exports = __webpack_public_path__ + "img/txt.7cce975f.svg";